module.exports = __webpack_public_path__ + "img/16k016-03.ecc9db50.jpg";